export default __webpack_public_path__ + "static/media/heroImg3.fd1b5d31.jpg";